
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import TahsilatList from "@/components/lists/TahsilatList.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import AlacakKalemiDetayForm from "@/components/takip/form/AlacakKalemiDetayForm.vue";
import KapakHesabiAlacakKalemleriInfo from "@/components/infos/KapakHesabiAlacakKalemleriInfo.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import {AlacakKalemiAlani, AlacakKalemiAlaniLabel} from "@/enum/AlacakKalemiAlani";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import KapakHesabi from "@/classes/evrak/KapakHesabi/KapakHesabi";
import KapakHesabiCalculator from "@/classes/evrak/KapakHesabi/KapakHesabiCalculator";
import {TahsilatEntity} from "@/entity/TahsilatEntity";
import OnizleForm from "@/components/forms/OnizleForm.vue";
import {TakipDurumu} from "@/enum/TakipDurumu";
import MasrafHarcForm from "@/components/forms/MasrafHarcForm.vue";
import IhtiyatiHacizAlacakKalemiForm from "@/components/forms/alacak-kalemi/IhtiyatiHacizAlacakKalemiForm.vue";
import {TakipYoluLabel} from "@/enum/TakipYolu";
import FormWrapper from "@/components/FormWrapper.vue";
import Dates from "@/components/inputs/Dates.vue";
import HesapTarihiForm from "@/components/forms/HesapTarihiForm.vue";
import HarcAlacakKalemleriInfo from "@/components/infos/HarcAlacakKalemleriInfo.vue";
import BorcluForm from "@/components/forms/BorcluForm.vue";
import TakipAlacakliPicker from "@/components/pickers/TakipAlacakliPicker.vue";
import AlacakList from "@/components/lists/AlacakList.vue";
import DokumanList from "@/components/lists/DokumanList.vue";
import {TahsilatTuru} from "../../enum/TahsilatTuru";
import DokumanForm from "@/components/forms/DokumanForm.vue";
import VekaletBankaHesabiSec from "@/components/lists/VekaletBankaHesabiSec.vue";
import {VekaletEntity} from "@/entity/VekaletEntity";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {KullanilacakDilekceler} from "@/enum/KullanilacakDilekceler";
import {TakipTipi} from "@/enum/TakipTipi";
import TakipEksikBilgilerDialog from "@/components/dialogs/TakipEksikBilgilerDialog.vue";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";
import {takipteBsmvAlaniniGoster} from "@/helpers/TakipTipiEskiNoHelper";
interface HataMesaji {
  key: string;
  mesaj: any;
}
@Component({
  computed: {
    TahsilatTuru() {
      return TahsilatTuru
    }
  },
  components: {
    TakipEksikBilgilerDialog,
    VekaletBankaHesabiSec,
    DokumanForm,
    DokumanList,
    AlacakList,
    TakipAlacakliPicker,
    BorcluForm,
    HarcAlacakKalemleriInfo,
    HesapTarihiForm,
    Dates,
    FormWrapper,
    IhtiyatiHacizAlacakKalemiForm,
    MasrafHarcForm,
    OnizleForm,
    FormDialog,
    KapakHesabiAlacakKalemleriInfo,
    AlacakKalemiDetayForm,
    TahsilatList,
  },
})
export default class KapakHesabiInfo extends Vue {

  @Prop() takip!: TakipEntity;
  @Prop({default: false}) IsHesapTarihi!: boolean;


  kapakHesabi: KapakHesabi = new KapakHesabi();
  tab = null;
  items = [{tab: 'Kapak Hesabı', content: 'Tab 1 Content'}];

  TakipDurumu = TakipDurumu;
  ParaBirimi = ParaBirimi;
  AlacakKalemiAlaniLabel = AlacakKalemiAlaniLabel;
  AlacakKalemiAlani = AlacakKalemiAlani;
  KullanilacakDilekceler = KullanilacakDilekceler;
  TakipYoluLabel = TakipYoluLabel;
  show = false;
  xmlUyari = false;
  hataMesajlari:HataMesaji[] = [];
  takipAcOnline = false
  takipAcManuel = false
// data
  vekaletItem: VekaletEntity | null = null;
  vekaletItemVisible = false;
  vekaletLoading = false;

  // ===== YENİ EKLENEN DATA PROPERTY'LERİ =====
  tahsilatUyariDialog: boolean = false;
  bekleyenXmlIndirmeTipi: string | null = null;
  tazyikHapsiDialog: boolean = false;
  tazyikDilekcesiSablon: string | null = null;
  tazyikDilekcesiLoading: boolean = false;
  tazyikDilekcesiPdfLoading: boolean = false;


  ibanHataMesaji() {
    if (this.hataMesajlari.some(m => m.key === 'Takip Talebi IBAN')) {
      this.vekaletLoad();
    }
  }
  async vekaletLoad() {
    try {
      this.vekaletLoading = true;
      this.vekaletItemVisible = false;
      this.vekaletItem = null;

      // Açılmamış takip (ekleme ekranı) vs açılmış takip (detay) ayrımı
      let alacakli: any;
      if (this.takip?.takip_durumu === this.TakipDurumu.acilmamis) {
        alacakli = this.$store?.state?.takipEkle?.takipAlacaklilar?.data?.[0];
      } else {
        alacakli = this.$store?.state?.takipDetay?.faizData?.data?.alacaklilar?.[0];
      }

      const vekaletId = alacakli?.vekalet_id || alacakli?.vekalet_no;
      if (!vekaletId) {
        // veri yoksa butonu devre dışı bırakacağız
        return;
      }

      const { data } = await this.$http.get('/api/v1/vekalet-detay-list/' + vekaletId);
      this.vekaletItem = data;
      this.vekaletItemVisible = true;
    } catch (e) {
      this.$toast && this.$toast.error('Vekalet bilgisi yüklenemedi.');
      this.vekaletItem = null;
      this.vekaletItemVisible = false;
    } finally {
      this.vekaletLoading = false;
    }
  }

  get tahsilatTutari() {
    let toplam = 0;
    this.takip?.tahsilatlar.forEach((tahsilat: TahsilatEntity) => {
      if (tahsilat.para_birimi_id == this.ParaBirimi.TRY)
        toplam += Number(tahsilat.tutar);
      else {
        toplam += Number(tahsilat.tutar) * tahsilat.kur
      }
    })
    return toplam;
  }

  get dokumanVekaletnameAction(){
    let alacakli!:any
    let action!:any

    if (this.takip.takip_durumu==this.TakipDurumu.acilmamis){
      alacakli = this.$store.state.takipEkle.takipAlacaklilar.data[0]
    }else{
      alacakli = this.$store.state.takipDetay.faizData.data.alacaklilar[0]
    }
    this.hataMesajlari.forEach(mesaj=>{
      if (mesaj.key =='MUVEKKILVEKALETNAME'){
        if (alacakli.muvekkil_kisi_id)
          action = "/api/v1/kisi/" + alacakli.muvekkil_kisi_id;
        else
          action = "/api/v1/kurum/" + alacakli.muvekkil_kurum_id;

      }else if(mesaj.key =='VEKALETVEKALETNAME'){
        action = "/api/v1/vekalet/" + alacakli.vekalet_id;
      }else if(mesaj.key =='TAKİPVEKALETNAME'){
        action = "/api/v1/takip/" + this.takip.id;
      }

    })
    return action
  }

  onlineXmlDownload(){
    this.initiateXmlDownload(this.takip.id,'online')
    this.takipAcOnline = false
  }

  manuelXmlDownload(){
    this.initiateXmlDownload(this.takip.id,'manuel')
    this.takipAcManuel = false
  }

  get isInvalidTakipData() {
    // Takip objesi yoksa veya sadece message içeriyorsa true döner
    return !this.takip ||
        !this.takip.id ||
        (typeof this.takip === 'object' && 'message' in this.takip && !('id' in this.takip));
  }

  /** Para alacağı / alacak kalemi olmayan takiplerde BSMV kaydı yok; checkbox PUT hatasına yol açıyor (54, 56). */
  get kapakHesabindaBsmvGoster(): boolean {
    return takipteBsmvAlaniniGoster(
      this.takip?.talepler?.[0]?.takip_tipi?.takip_tipi_eski_no
    );
  }

  mounted() {
    if (!this.kapakHesabi) {
      this.kapakHesabi = new KapakHesabi();
    }
    if (!this.isInvalidTakipData) {
      this.calculateKapakHesabi();
    }
    this.dokumanVekaletnameAction
  }

  onizle() {
    this.calculateKapakHesabi();
  }

  dortteUcMu() {
    if (this.$route.params.id != null) {
      const dortteUcMu = this.takip.vekalet_ucreti_dortte_uc_mu;

      this.$http
          .put('/api/v1/takip/' + parseInt(this.$route.params.id), this.takip)
          .then((response: any) => {
            const updatedTakip = response.data;
            updatedTakip.vekalet_ucreti_dortte_uc_mu = dortteUcMu;
            this.takip = updatedTakip;
            this.load();
          });
    }
  }

  get bsmvDegeri(): boolean {
    return this.takip?.talepler?.[0]?.alacaklar?.[0]?.bsmv ?? false;
  }

  set bsmvDegeri(val: boolean) {
    if (this.takip?.talepler?.[0]?.alacaklar?.[0]) {
      this.takip.talepler[0].alacaklar[0].bsmv = val;
    }
  }

  bsmvDegistir() {
    if (this.$route.params.id != null && this.takip?.talepler?.[0]?.alacaklar?.[0]?.id) {
      const alacakId = this.takip.talepler[0].alacaklar[0].id;
      this.$http
          .put('/api/v1/alacak/' + alacakId, {
            ...this.takip.talepler[0].alacaklar[0],
            takip_tipi_id: this.takip.talepler[0].takip_tipi_id,
            takip_talebi_id: this.takip.talepler[0].id,
          })
          .then(() => {
            this.load();
          });
    }
  }

  get alacakKalemiAlanlari() {
    let alacakKalemiAlanlari: Array<any> = [];
    this.kapakHesabi?.alacakKalemiAlanlari.forEach((alacakKalemiAlaniId) => {
      this.takip.talepler[0].alt_tip_hesap_ayar.forEach((item) => {
        if (item.alacak_kalemi_alani_id === alacakKalemiAlaniId) {
          if (alacakKalemiAlaniId === AlacakKalemiAlani.eklenenNafaka) {
            // Birikmiş nafaka takip sonrası faizin üstünde gösterilecek
          } else if (item.oran) {
            if (item.etiket){
              let alan = {id: item.alacak_kalemi_alani_id, ad: item.etiket+ (item.oran!=0 ? ` (% ${item.oran})` : '')}
              alacakKalemiAlanlari.push(alan)
            }else{
              let alan = {id: item.alacak_kalemi_alani_id, ad: item.alacak_kalemi_alani.isim+ (item.oran!=0 ? ` (% ${item.oran})` : '')}
              alacakKalemiAlanlari.push(alan)
            }

          } else {
            if (item.etiket){
              let alan = {id: item.alacak_kalemi_alani_id, ad: item.etiket}
              alacakKalemiAlanlari.push(alan)
            }else{
              let alan = {id: item.alacak_kalemi_alani_id, ad: AlacakKalemiAlaniLabel[alacakKalemiAlaniId]}
              alacakKalemiAlanlari.push(alan)
            }

          }
        }
      })
    })
    return alacakKalemiAlanlari
  }

  get takipSonrasiAlacakKalemiAlanlari() {
    let takipSonrasialacakKalemiAlanlari: Array<any> = [];
    this.kapakHesabi.takipSonrasialacakKalemiAlanlari.forEach((takipSonrasiAlacakKalemiAlaniId) => {
      this.takip.talepler[0].alt_tip_hesap_ayar.forEach((item) => {
        if (item.alacak_kalemi_alani_id === takipSonrasiAlacakKalemiAlaniId) {
          if (takipSonrasiAlacakKalemiAlaniId === AlacakKalemiAlani.eklenenNafaka) {
            let takipSonrasiAlan = {id: item.alacak_kalemi_alani_id, ad: 'Eklenen Nafaka', isNafaka: true, isTakipOncesi: false}
            takipSonrasialacakKalemiAlanlari.push(takipSonrasiAlan)
          } else if (item.etiket) {
            if (item.oran){
              let takipSonrasiAlan = {id: item.alacak_kalemi_alani_id, ad: item.etiket+ (item.oran!=0 ? ` (% ${item.oran})` : '')}
              takipSonrasialacakKalemiAlanlari.push(takipSonrasiAlan)
            }else{
              let takipSonrasiAlan = {id: item.alacak_kalemi_alani_id, ad: item.etiket}
              takipSonrasialacakKalemiAlanlari.push(takipSonrasiAlan)
            }
          } else {
            if (item.oran){
              let takipSonrasiAlan = {id: item.alacak_kalemi_alani_id, ad: item.alacak_kalemi_alani.isim+ (item.oran!=0 ? ` (% ${item.oran})` : '')}
              takipSonrasialacakKalemiAlanlari.push(takipSonrasiAlan)
            }else{
              let takipSonrasiAlan = {id: item.alacak_kalemi_alani_id, ad: AlacakKalemiAlaniLabel[takipSonrasiAlacakKalemiAlaniId]}
              takipSonrasialacakKalemiAlanlari.push(takipSonrasiAlan)
            }

          }
        }
      })
    })
    return takipSonrasialacakKalemiAlanlari
  }

  get alacakKalemleri() {
    if (this.takip && this.takip.talepler[0] && this.takip.talepler[0].alacaklar && this.takip.talepler[0].alacaklar.length > 0) {
      if (this.takip.talepler[0] && this.takip.talepler[0].alacaklar && this.takip.talepler[0].alacaklar[0].asil_alacaklar && this.takip.talepler[0].alacaklar[0].asil_alacaklar.length > 0) {
        return true;
      }
    } else {
      return false
    }
  }

  get hasVekilDisiBankaHesabiSahibi(): boolean {
    return (this.takip?.alacaklilar ?? []).some(
        item => item.muvekkil?.vekalet?.varsayilan_banka_hesabi_sahibi !== 'vekil'
    );
  }

  get checkVadeTarihliKur(){
    return this.takip.talepler[0].alacaklar.map(alacak => alacak.kur).some(kur => kur != null)
  }

  checkTahsilatTarihliKur(){
    return this.takip.talepler[0].alacaklar.map(alacak => alacak.doviz_kur_tarihi).some(kur => kur == 'tahsilat')
  }

  get alacakBelgeTuruId(): number | null {
    if (this.takip && this.takip.talepler[0]?.alacaklar) {
      return this.takip.talepler[0]?.alacaklar[0].alacak_belge_turu_id;
    }
    return null;
  }

  get hasBirikmisNafaka(): boolean {
    return this.kapakHesabi?.takipSonrasialacakKalemiAlanlari?.includes(AlacakKalemiAlani.eklenenNafaka) ?? false;
  }

  isTakipOncesiNafaka(alacakKalemiAlaniId: number): boolean {
    if (alacakKalemiAlaniId !== AlacakKalemiAlani.eklenenNafaka) {
      return false;
    }
    return this.hasBirikmisNafaka;
  }

  getNafakaLabel(alacakKalemiAlaniId: number, isTakipOncesi: boolean): string {
    if (alacakKalemiAlaniId !== AlacakKalemiAlani.eklenenNafaka) {
      return '';
    }
    return isTakipOncesi ? 'Birikmiş Nafaka' : 'Eklenen Nafaka';
  }


  @Watch('tazyikHapsiDialog')
  async onTazyikHapsiDialogChange(val: boolean) {
    if (val && !this.tazyikDilekcesiSablon) {
      await this.fetchTazyikDilekcesi();
    }
  }

  async fetchTazyikDilekcesi() {
    try {
      this.tazyikDilekcesiLoading = true;
      const response = await this.$helper.requestWithCache('/api/v1/dilekce-list');
      const data = response?.data;
      const list = data?.data ?? data;
      const takipTipiId = this.takip?.talepler?.[0]?.takip_tipi_id;
      const dilekceId = takipTipiId === TakipTipi.paraBorcuVeyaTeminat
        ? this.KullanilacakDilekceler.ilamli_tazyik_dilekcesi
        : this.KullanilacakDilekceler.ilamsiz_tazyik_dilekcesi;
      const tazyikDilekce = Array.isArray(list)
        ? list.find((d: any) => d.id === dilekceId)
        : null;
      this.tazyikDilekcesiSablon = tazyikDilekce?.sablon || null;
    } catch (e) {
      this.$toast && this.$toast.error('Tazyik dilekçesi yüklenemedi.');
      this.tazyikDilekcesiSablon = null;
    } finally {
      this.tazyikDilekcesiLoading = false;
    }
  }

  get tazyikDilekcesiGosterim(): string {
    if (!this.tazyikDilekcesiSablon) return '';
    const icraDairesi = this.takip?.icra_dairesi?.isim || '.........';
    const dosyaNo = this.takip?.dosya_no || this.takip?.dosya_esas_no || '.........';
    return this.tazyikDilekcesiSablon
      .replace(/\{\{icra_dairesi\}\}/g, icraDairesi)
      .replace(/\{\{dosya_no\}\}/g, dosyaNo);
  }

  tazyikHapsiDilekceyiKopyala() {
    const dilekce = this.tazyikDilekcesiGosterim;
    if (!dilekce) {
      this.$toast && this.$toast.error('Dilekçe şablonu yüklenemedi.');
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(dilekce).then(() => {
        this.$toast.success('Dilekçe kopyalandı.');
      });
    }
    this.tazyikHapsiDialog = false;
  }

  tazyikDilekcesiDosyaAdi(): string {
    const dosyaNo = this.takip?.dosya_no || this.takip?.dosya_esas_no || 'dilekce';
    return `${dosyaNo}_tazyik_dilekcesi`;
  }

  tazyikDilekcesiYazdir() {
    if (!this.tazyikDilekcesiSablon) {
      this.$toast && this.$toast.error('Dilekçe şablonu yüklenemedi.');
      return;
    }
    this.$helper.printComponent('tazyikDilekcesi');
  }

  tazyikDilekcesiWordIndir() {
    if (!this.tazyikDilekcesiSablon) {
      this.$toast && this.$toast.error('Dilekçe şablonu yüklenemedi.');
      return;
    }
    const header =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:w='urn:schemas-microsoft-com:office:word' " +
        "xmlns='http://www.w3.org/TR/REC-html40'>" +
        "<head><meta charset='utf-8'></head><body>";
    const footer = "</body></html>";
    const sourceHTML = header + (document.getElementById('tazyikDilekcesi')?.innerHTML ?? '') + footer;
    const source =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(sourceHTML);
    const fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = this.tazyikDilekcesiDosyaAdi() + ".doc";
    fileDownload.click();
    document.body.removeChild(fileDownload);
  }

  tazyikDilekcesiUdfIndir() {
    if (!this.tazyikDilekcesiSablon) {
      this.$toast && this.$toast.error('Dilekçe şablonu yüklenemedi.');
      return;
    }
    this.$helper.getUdfFromComponent('tazyikDilekcesi', true, this.tazyikDilekcesiDosyaAdi());
  }

  async tazyikDilekcesiImzaliUdfIndir() {
    if (!this.tazyikDilekcesiSablon) {
      this.$toast && this.$toast.error('Dilekçe şablonu yüklenemedi.');
      return;
    }
    await this.$helper.getImzaliUdfFromComponent('tazyikDilekcesi', true, this.tazyikDilekcesiDosyaAdi() + '_imzali');
  }

  async tazyikDilekcesiPdfIndir() {
    if (!this.tazyikDilekcesiSablon) {
      this.$toast && this.$toast.error('Dilekçe şablonu yüklenemedi.');
      return;
    }
    try {
      this.tazyikDilekcesiPdfLoading = true;
      const html2pdf = (await import('html2pdf.js/dist/html2pdf')).default;
      const rawHtml = document.getElementById('tazyikDilekcesi')?.innerHTML ?? '';
      const printable = `
          <!doctype html>
          <html lang="tr">
            <head>
              <meta charset="utf-8" />
              <style>
                .pdf-wrap{
                  line-height:1.5;
                  font-family:'Times New Roman', serif;
                  font-size:12pt;
                  white-space:pre-wrap;
                  word-break:break-word;
                  overflow-wrap:anywhere;
                  hyphens:auto;
                }
                .pdf-wrap p{ margin:0; }
              </style>
            </head>
            <body><div class="pdf-wrap">${rawHtml}</div></body>
          </html>`;
      await html2pdf()
          .from(printable)
          .set({
            margin: [15, 15, 20, 15],
            filename: `${this.tazyikDilekcesiDosyaAdi()}.pdf`,
            image: { type: 'jpeg', quality: 1.0 },
            html2canvas: {
              scale: 2.5,
              useCORS: true,
              letterRendering: true,
              allowTaint: true,
              logging: false,
              imageTimeout: 0,
              removeContainer: true,
            },
            jsPDF: {
              unit: 'mm',
              format: 'a4',
              orientation: 'portrait',
              compress: true,
              precision: 16,
            },
          })
          .save();
    } catch (e: any) {
      this.$toast && this.$toast.error('PDF oluşturulamadı: ' + (e?.message || 'Bilinmeyen hata'));
    } finally {
      this.tazyikDilekcesiPdfLoading = false;
    }
  }

  @Watch('takip')
  onTakipChange() {
    this.calculateKapakHesabi();
  }
  /*@Watch('hataMesajlari')
  onHataMesajlariChanged() {
    // ibanHataMesaji() artık burada çağrılmıyor
    // xmlDownload catch bloğunda zaten manuel olarak çağrılıyor
    // Bu sayede 2 ayrı API isteği yerine 1 istek gidiyor
  }*/


  calculateKapakHesabi() {
    if (this.takip.id) {
      let kapakHesabiCalculator: KapakHesabiCalculator = new KapakHesabiCalculator();
      kapakHesabiCalculator.setTakip(this.takip);
      this.kapakHesabi = kapakHesabiCalculator.calculateKapakHesabi();
      this.kapakHesabi.alacakKalemiAlanlari.sort(function (a, b) {
        return a - b;
      });
      this.kapakHesabi.takipSonrasialacakKalemiAlanlari.sort(function (a, b) {
        return a - b;
      });
    }

  }

  load() {
    this.$emit('load')
  }


  get cezaEviHarci(){
    let tahsilatlar:any = []

    this.takip.tahsilatlar.forEach((tahsilat:any)=>{
      tahsilatlar ={"cezaevi_harci":tahsilat.cezaevi_harci,
        "tahsilat_turu": tahsilat.tahsilat_turu}
    })
    return tahsilatlar
  }

  // ===== YENİ EKLENEN METOTLAR =====
  initiateXmlDownload(id: number, tip: string) {
    if (this.takip && this.takip.tahsilatlar && this.takip.tahsilatlar.length > 0) {
      this.bekleyenXmlIndirmeTipi = tip;
      this.tahsilatUyariDialog = true;
    } else {
      this.xmlDownload(id, tip);
    }
  }

  proceedWithXmlDownload() {
    if (this.bekleyenXmlIndirmeTipi) {
      this.xmlDownload(this.takip.id, this.bekleyenXmlIndirmeTipi);
      this.tahsilatUyariDialog = false;
      this.bekleyenXmlIndirmeTipi = null;
    }
  }
  // ===== METOT EKLEMELERİ SONU =====


  async xmlDownload(id: number, tip: string, returnFile: boolean = false): Promise<File | void> {
    this.hataMesajlari = [];
    this.xmlUyari = false;
    this.show = true;
    StatusCodeHelper.dontShow422Alert = true;
    try {
      const xmlName = 'İcraProTakipXml-' + parseInt(this.$route.params.id) + '.xml';
      const file = await this.$helper.requestXmlFile('/api/v1/takip/' + parseInt(this.$route.params.id) + '/' + tip + 'xml', {
        returnFile,
        fallbackFileName: xmlName
      });
      this.xmlUyari = false;
      this.show = false;
      if (returnFile)
        return file;
    } catch (error) {
      const errorData = error?.response?.data;
      if (Array.isArray(errorData)) {
        errorData.forEach((data: any) => {
          for (const [key, value] of Object.entries(data)) {
            this.hataMesajlari.push({key: key, mesaj: value});
          }
        });
      } else if (errorData) {
        if (errorData.message) {
          this.hataMesajlari.push({key: 'message', mesaj: errorData.message});
        }
        if (errorData.error) {
          this.hataMesajlari.push({key: 'error', mesaj: errorData.error});
        }
      }
      this.xmlUyari = this.hataMesajlari.length > 0;
      this.ibanHataMesaji();
      throw new Error(error);
    } finally {
      StatusCodeHelper.dontShow422Alert = false;
    }
  }

  async eicraproIleTakipAc(id: number, tip: string) {
    if (this.takip && this.takip.tahsilatlar && this.takip.tahsilatlar.length > 0) {
      this.bekleyenXmlIndirmeTipi = tip;
      this.tahsilatUyariDialog = true;
    } else {
      try {
        let file = await this.xmlDownload(id, tip, true);
        this.$store.state.xml = file;
        this.$router.push(ProgramPaths.eicrapro + "/takip-hazirla?icw=true");
      } catch (e) {
        console.error(e);
      }
    }
  }

  handleSave() {
    // Kaydet butonuna tıklandığında yapılacak işlemler
    // Şu an için sadece dialog'u kapatıyoruz
    this.show = false;
  }

  handleXmlDownload(id: number, tip: string) {
    this.show = true;
    this.initiateXmlDownload(id, tip);
  }

  print() {

    this.$helper.printComponent('kapakHesabiInfo');
  }
}
